<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.path + getRouteKey($route)" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view :key="$route.path + getRouteKey($route)" v-if="!$route.meta.keepAlive">
    </router-view>
    <!-- <router-view /> -->
    <Tabbar v-if="$route.meta.TabbarShow"></Tabbar>
  </div>
</template>

<script>
import Tabbar from './components/Tabbar.vue'
export default {
  name: 'App',
  components: { Tabbar },
  methods: {
    getRouteKey(route) {
      if (route.meta && route.meta.key) {
        const key = route.meta.key
        if (typeof key === 'function') {
          return key(route)
        }
        return key
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  font-family: 'PingFang SC';
  height: 100vh;
  width: 100vw;
  // overflow: auto;
  // overflow-y: hidden;
  background: #fff;
  overflow-x: hidden;
}
</style>
